import {atom} from 'recoil'

export const encryptionSettings = atom (
  {
    key: 'encryption_settings',
    default: null
  }
)